export default "__VITE_ASSET__z1_5M5qp__"